const positions = [
  'Administrative Assistant',
  'Assistant General Manager',
  'Assistant Manager',
  'Assistant Retail Manager',
  'Assistant Store Manager',
  'Back Office',
  'Banquet Server',
  'Barback',
  'Barista',
  'Bartender',
  'Beauty Advisor',
  'Bellhop',
  'Busboy',
  'Business Development',
  'Busser',
  'Call Center Rep',
  'Cashier',
  'Catering Assistant',
  'Catering Manager',
  'Chef',
  'Cleaner',
  'Clerk',
  'Client Representative',
  'Conicierge',
  'Cook',
  'Customer Experience Manager',
  'Customer Service',
  'Customer Service Rep',
  'Dishwasher',
  'Driver',
  'Executive Chef',
  'Facilities Coordinator',
  'Finance',
  'Food and Beverage Manager',
  'Food Service Associate',
  'Food Service Director',
  'Front Desk',
  'Gaming Service Worker',
  'General Manager',
  'Guest Services',
  'Head Waiter',
  'Health and Safety',
  'Hospitality Coordinator',
  'Host',
  'Host',
  'Hotel Manager',
  'House Keeper',
  'Inventory Control Specialist',
  'Kitchen Crew Member',
  'Kitchen Manager',
  'Logistics',
  'Maid',
  'Maintenance',
  'Opener',
  'Operations',
  'Operations Manager',
  'Pastry Chef',
  'Porter',
  'Prep Cook',
  'Receptionist',
  'Recruiter',
  'Reservations',
  'Restaurant Manager',
  'Retail Manager',
  'Retail Salesperson',
  'Runner',
  'Safety Associate',
  'Sales',
  'Sales Associate',
  'Sales Manager',
  'Security',
  'Server',
  'Server',
  'Service Delivery',
  'Shift Manager',
  'Shift Supervisor',
  'Sommelier',
  'Sous Chef',
  'Stocker',
  'Store Manager',
  'Takeout',
  'Talent Acquisition Manager',
  'Utility Expo',
  'Valet',
  'Warehouse Worker',
  'No position'
];

export default positions;
